//Local API url
// export const API_URL="http://localhost:8080/";

//UAT API url
// export const API_URL="https://lifecellwellnessapiuat.altius.cc/";

//Live API url
export const API_URL="https://nineandfineapi.altius.cc/";



//Local Web url
// export const WEB_URL="http://localhost:3000/";

//UAT Web url
// export const WEB_URL="https://lifecellwellnessuat.altius.cc/";

//Live Web url
export const WEB_URL="https://nineandfine.com/";

